import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';

export const otpGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  if (localStorage.getItem('policyGuestMode') === 'true' && state.url.startsWith('/kga-website')) {
    return true;
  }

  const otpVerified = sessionStorage.getItem('otpVerified') === 'true';
  const hasToken = !!localStorage.getItem('userToken');

  if (hasToken && otpVerified) {
    if (sessionStorage.getItem('otpVerifiedSession') !== 'true') {
      sessionStorage.setItem('otpVerifiedSession', 'true');
    }
    return true;
  }

  return router.createUrlTree(['/sign-in']);
};
